import { generateKeys, generateLocalization } from '../utils';
import { companies } from './companies';
import { getApplicableOptions, appropTestEducationLevel, appropTestFieldOfStudy, appropTestPast2YearsTradingExperience, appropTestTransactionsInForex, appropTestTransactionsInCommodities, appropTestWithLeverageForex, appropTestWithLeverageCommodities } from './appropTest';
const suitabilityTestSteps = generateLocalization('suitabilityTestSteps', generateKeys({
    accountSelection: {
        stepPosition: () => 0,
        label: 'Select option',
        localization: { id: '', defaultMessage: '' },
        skip: (value) => (true === value),
    },
    currency: {
        stepPosition: (submitted, firstStep) => submitted ? -1 : firstStep ? 0 : 1,
        label: 'Select base currency',
        localization: { id: '', defaultMessage: '' },
        skip: (value) => (true === value),
    },
    knowledgeDemonstation: {
        stepPosition: (submitted, firstStep) => submitted ? 0 : firstStep ? 1 : 2,
        label: 'Knowledge Demonstation',
        localization: { id: '', defaultMessage: '' },
        skip: () => false,
    },
    financialSituation: {
        stepPosition: (submitted, firstStep) => submitted ? 1 : firstStep ? 2 : 3,
        label: 'Financial Situation',
        localization: { id: '', defaultMessage: '' },
        skip: () => false,
    },
    investmentExperience: {
        stepPosition: (submitted, firstStep) => submitted ? 2 : firstStep ? 3 : 4,
        label: 'Investment Experience',
        localization: { id: '', defaultMessage: '' },
        skip: () => false,
    },
}));
const suitabilityTestYearsOfExperience = generateLocalization('suitabilityTestYearsOfExperience', generateKeys({
    oneToFiveYears: {
        value: 'oneToFiveYears',
        localization: { id: '', defaultMessage: '' },
        label: '1 - 5 years',
    },
    fiveToTenYears: {
        value: 'fiveToTenYears',
        localization: { id: '', defaultMessage: '' },
        label: '5 - 10 years',
    },
    moreThanTenYears: {
        value: 'moreThanTenYears',
        localization: { id: '', defaultMessage: '' },
        label: 'More than 10 years',
    },
    noExperience: {
        value: 'noExperience',
        localization: { id: '', defaultMessage: '' },
        label: 'No Experience',
    },
}));
const suitabilityTestPrimaryInvestmentGoal = generateLocalization('suitabilityTestPrimaryInvestmentGoal', generateKeys({
    shortTerm: {
        value: 'shortTerm',
        localization: { id: '', defaultMessage: '' },
        label: 'Assuring short term liquidity management',
        portfolio_points: 1,
    },
    longTerm: {
        value: 'longTerm',
        localization: { id: '', defaultMessage: '' },
        label: 'Assuring long term resources, saving',
        portfolio_points: 2,
    },
    highProfit: {
        value: 'highProfit',
        localization: { id: '', defaultMessage: '' },
        label: 'Making high profit even at the risk of losing the principal amount',
        portfolio_points: 3,
    },
}));
const suitabilityTestPrimaryInvestmentTerm = generateLocalization('suitabilityTestPrimaryInvestmentTerm', generateKeys({
    lessThanOneYear: {
        value: 'lessThanOneYear',
        localization: { id: '', defaultMessage: '' },
        label: 'less than 1 year',
        portfolio_points: 4,
    },
    oneToThreeYears: {
        value: 'oneToThreeYears',
        localization: { id: '', defaultMessage: '' },
        label: '1 - 3 years',
        portfolio_points: 3,
    },
    threeToFiveYears: {
        value: 'threeToFiveYears',
        localization: { id: '', defaultMessage: '' },
        label: '3 - 5 years',
        portfolio_points: 2,
    },
    overFiveYears: {
        value: 'overFiveYears',
        localization: { id: '', defaultMessage: '' },
        label: 'over 5 years',
        portfolio_points: 1,
    },
}));
const suitabilityTestInvestmentFrequency = generateLocalization('suitabilityTestInvestmentFrequency', generateKeys({
    noInvestments: {
        value: 'noInvestments',
        localization: { id: '', defaultMessage: '' },
        label: 'No investments up to this date',
        portfolio_points: 1,
    },
    fewTimes: {
        value: 'fewTimes',
        localization: { id: '', defaultMessage: '' },
        label: 'Few times a year',
        portfolio_points: 2,
    },
    monthly: {
        value: 'monthly',
        localization: { id: '', defaultMessage: '' },
        label: 'Monthly',
        portfolio_points: 3,
    },
    severalTimes: {
        value: 'severalTimes',
        localization: { id: '', defaultMessage: '' },
        label: 'I trade several times a month or actively',
        portfolio_points: 4,
    },
}));
const suitabilityTestPercentageInvestmentAvailable = generateLocalization('suitabilityTestPercentageInvestmentAvailable', generateKeys({
    underTen: {
        value: 'underTen',
        localization: { id: '', defaultMessage: '' },
        label: 'Under 10%',
        portfolio_points: 1,
    },
    tenTotwentyFive: {
        value: 'tenTotwentyFive',
        localization: { id: '', defaultMessage: '' },
        label: '10 - 25%',
        portfolio_points: 2,
    },
    aboveTwentyFive: {
        value: 'aboveTwentyFive',
        localization: { id: '', defaultMessage: '' },
        label: 'Above 25%',
        portfolio_points: 3,
    },
}));
const suitabilityTestWealth = generateLocalization('suitabilityTestWealth', generateKeys({
    belowFifty: {
        value: 'belowFifty',
        localization: { id: '', defaultMessage: '' },
        label: 'below USD 50,000',
        portfolio_points: 1,
    },
    fiftyToHundred: {
        value: 'fiftyToHundred',
        localization: { id: '', defaultMessage: '' },
        label: 'between USD 50,000 – 100,000',
        portfolio_points: 2,
    },
    hundredToTwoHundred: {
        value: 'hundredToTwoHundred',
        localization: { id: '', defaultMessage: '' },
        label: 'between USD 100,000 – 200,000',
        portfolio_points: 3,
    },
    overTwoHundred: {
        value: 'overTwoHundred',
        localization: { id: '', defaultMessage: '' },
        label: 'over USD 200,000',
        portfolio_points: 4,
    },
}));
const suitabilityTestDisposableIncome = generateLocalization('suitabilityTestDisposableIncome', generateKeys({
    belowTwoHundred: {
        value: 'belowTwoHundred',
        localization: { id: '', defaultMessage: '' },
        label: 'below USD 200/month',
        portfolio_points: 1,
    },
    twoHundredtoThousand: {
        value: 'twoHundredtoThousand',
        localization: { id: '', defaultMessage: '' },
        label: 'between USD 200 – 1000/month',
        portfolio_points: 2,
    },
    overThousand: {
        value: 'overThousand',
        localization: { id: '', defaultMessage: '' },
        label: 'over USD 1000/month',
        portfolio_points: 3,
    },
}));
const suitabilityTestIncomeSources = generateLocalization('suitabilityTestIncomeSources', generateKeys({
    salary: {
        value: 'salary',
        localization: { id: '', defaultMessage: '' },
        label: 'Salary',
        portfolio_points: 1,
    },
    capitalIncome: {
        value: 'capitalIncome',
        localization: { id: '', defaultMessage: '' },
        label: 'Capital income',
        portfolio_points: 2,
    },
    enterpreneurialActivities: {
        value: 'enterpreneurialActivities',
        localization: { id: '', defaultMessage: '' },
        label: 'Income from entrepreneurial activities',
        portfolio_points: 3,
    },
    otherIncome: {
        value: 'otherIncome',
        localization: { id: '', defaultMessage: '' },
        label: 'other income',
        portfolio_points: 4,
    },
}));
const suitabilityTestCharacterizeInvestment = generateLocalization('suitabilityTestCharacterizeInvestment', generateKeys({
    belowTwoHundred: {
        value: 'belowTwoHundred',
        localization: { id: '', defaultMessage: '' },
        label: 'below USD 2000',
        portfolio_points: 1,
    },
    betweenTwoToTwenty: {
        value: 'betweenTwoToTwenty',
        localization: { id: '', defaultMessage: '' },
        label: 'between USD 2000-20,000',
        portfolio_points: 2,
    },
    overTwenty: {
        value: 'overTwenty',
        localization: { id: '', defaultMessage: '' },
        label: 'Over USD 20,000',
        portfolio_points: 3,
    },
    multipleAmounts: {
        value: 'multipleAmounts',
        localization: { id: '', defaultMessage: '' },
        label: 'Multiple of the above-mentioned amounts owing to leverage',
        portfolio_points: 4,
    },
}));
const suitabilityTestRiskWillingness = generateLocalization('suitabilityTestRiskWillingness', generateKeys({
    lowRisk: {
        value: 'lowRisk',
        localization: { id: '', defaultMessage: '' },
        label: 'Taking low risks: I only take risks that do not jeopardize my principal under ordinary market conditions, but my invested capital may decrease under extreme circumstances. \(Examples to investments implying low risks: government bonds, bonds, money market and liquidity funds.\)',
        portfolio_points: 1,
    },
    mediumRisk: {
        value: 'mediumRisk',
        localization: { id: '', defaultMessage: '' },
        label: 'Taking medium risks: To reach a higher than average return, I am ready to risk a part of my principal. \(Examples to investments implying medium risks: investment funds other than the ones under point a), foreign bonds, shares.\)',
        portfolio_points: 2,
    },
    highRisk: {
        value: 'highRisk',
        localization: { id: '', defaultMessage: '' },
        label: 'Taking high risks: Hoping for high returns I risk a part or the entire amount of my investment even under ordinary market conditions. I am aware that a loss higher than the original amount may be incurred for certain investments, in which case I am able to provide additional coverage upon the Company’s request, if I hold such a product. \(Examples to investments implying high risks: beside products determined under points a\) and b\), options, futures, CFD through online trading.\)',
        portfolio_points: 3,
    },
}));
const suitabilityTestMostSpecific = generateLocalization('suitabilityTestMostSpecific', generateKeys({
    optionA: {
        value: 'optionA',
        localization: { id: '', defaultMessage: '' },
        label: 'The safety of my capital is the most important to me, therefore, to prevent risks I am ready to give up reaching high returns',
        portfolio_points: 1,
    },
    optionB: {
        value: 'optionB',
        localization: { id: '', defaultMessage: '' },
        label: 'Hoping for a higher than average return I accept taking higher risks and I am ready to accept the slight decrease of my capital',
        portfolio_points: 2,
    },
    optionC: {
        value: 'optionC',
        localization: { id: '', defaultMessage: '' },
        label: 'Hoping for high returns I am ready to take high risks even if a considerable part of my capital is at risk as a result, what is more, if I invest in a derivative product, the loss may exceed even the amount invested in the product concerned',
        portfolio_points: 3,
    },
}));
const suitabilityTestTermsConditions = generateLocalization('suitabilityTestTermsCondtions', generateKeys({
    agreedTerms1: {
        value: 'agreedTerms1',
        localization: { id: '', defaultMessage: '' },
        label: 'You have not been engaged in or have benefited from criminal conduct in any part of the world.',
    },
    agreedTerms2: {
        value: 'agreedTerms2',
        onlyText: true,
        localization: { id: '', defaultMessage: '' },
        label: 'The information given herein and the requested documents herby attached are to the best of your knowledge true and accurate as at the date hereof, and should there be any changes in the information provided you undertake to promptly advise our company of the same in writing.',
    },
}));
export const suitabilityTestQuestions = generateLocalization('SuitabilityTest', generateKeys({
    educationSuitabilityTest: {
        value: 'educationSuitabilityTest',
        localization: { id: '', defaultMessage: '' },
        order: 1,
        orderLabel: 1,
        label: 'Education',
        question: 'educationSuitabilityTestQuestion',
        options: getApplicableOptions(appropTestEducationLevel, 2),
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.knowledgeDemonstation,
        radioBtn: true,
    },
    fieldOfStudySuitabilityTest: {
        value: 'fieldOfStudySuitabilityTest',
        localization: { id: '', defaultMessage: '' },
        order: 2,
        orderLabel: 2,
        label: 'Field of study',
        question: 'fieldOfStudySuitabilityTestQuestion',
        options: getApplicableOptions(appropTestFieldOfStudy, 2),
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.knowledgeDemonstation,
        radioBtn: true,
    },
    past2YearsTradingExperienceSuitabilityTest: {
        value: 'past2YearsTradingExperienceSuitabilityTest',
        localization: { id: '', defaultMessage: '' },
        order: 3,
        orderLabel: 3,
        label: 'In the past 2 years I have',
        question: 'past2YearsTradingExperienceSuitabilityTestQuestion',
        options: getApplicableOptions(appropTestPast2YearsTradingExperience, 3),
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.knowledgeDemonstation,
        radioBtn: true,
    },
    transactionsInForexSuitabilityTest: {
        value: 'transactionsInForexSuitabilityTest',
        localization: { id: '', defaultMessage: '' },
        order: 4,
        orderLabel: 4,
        label: 'In the past 2 years what was the total volume of your transactions in forex',
        question: 'transactionsInForexSuitabilityTestQuestion',
        options: getApplicableOptions(appropTestTransactionsInForex, 2),
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.knowledgeDemonstation,
        radioBtn: true,
    },
    transactionsInCommoditiesSuitabilityTest: {
        value: 'transactionsInCommoditiesSuitabilityTest',
        localization: { id: '', defaultMessage: '' },
        order: 5,
        orderLabel: 5,
        label: 'In the past 2 years what was the total volume of your transactions in Commodities or Shares or Bonds or Indices',
        question: 'transactionsInCommoditiesSuitabilityTestQuestion',
        options: getApplicableOptions(appropTestTransactionsInCommodities, 2),
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.knowledgeDemonstation,
        radioBtn: true,
    },
    withLeverageForexSuitabilityTest: {
        value: 'withLeverageForexSuitabilityTest',
        localization: { id: '', defaultMessage: '' },
        order: 6,
        orderLabel: 6,
        label: 'In the past 2 years how many times have you traded the below with leverage in forex',
        question: 'withLeverageForexSuitabilityTestQuestion',
        options: getApplicableOptions(appropTestWithLeverageForex, 2),
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.knowledgeDemonstation,
        radioBtn: true,
    },
    withLeverageCommoditiesSuitabilityTest: {
        value: 'withLeverageCommoditiesSuitabilityTest',
        localization: { id: '', defaultMessage: '' },
        order: 7,
        orderLabel: 7,
        label: 'In the past 2 years how many times have you traded the below with leverage in Commodities or Shares or Bonds or Indices',
        question: 'withLeverageCommoditiesSuitabilityTestQuestion',
        options: getApplicableOptions(appropTestWithLeverageCommodities, 2),
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.knowledgeDemonstation,
        radioBtn: true,
    },
    primaryInvestmentGoal: {
        value: 'primaryInvestmentGoal',
        localization: { id: '', defaultMessage: '' },
        order: 8,
        orderLabel: 8,
        label: 'Primary investment goal',
        question: 'primaryInvestmentGoalQuestion',
        options: suitabilityTestPrimaryInvestmentGoal,
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.financialSituation,
        radioBtn: true,
    },
    primaryInvestmentTerm: {
        value: 'primaryInvestmentTerm',
        localization: { id: '', defaultMessage: '' },
        order: 9,
        orderLabel: 9,
        label: 'Primary investment term',
        question: 'primaryInvestmentTermQuestion',
        options: suitabilityTestPrimaryInvestmentTerm,
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.financialSituation,
        radioBtn: true,
    },
    investmentFrequency: {
        value: 'investmentFrequency',
        localization: { id: '', defaultMessage: '' },
        order: 10,
        orderLabel: 10,
        label: 'Investment frequency',
        question: 'investmentFrequencyQuestion',
        options: suitabilityTestInvestmentFrequency,
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.financialSituation,
        radioBtn: true,
    },
    percentageInvestmentAvailable: {
        value: 'percentageInvestmentAvailable',
        localization: { id: '', defaultMessage: '' },
        order: 11,
        orderLabel: 11,
        label: 'Percentage of your available financial assets you wish to invest in securities or financial instruments',
        question: 'investmentFrequencyQuestion',
        options: suitabilityTestPercentageInvestmentAvailable,
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.financialSituation,
        radioBtn: true,
    },
    wealth: {
        value: 'wealth',
        localization: { id: '', defaultMessage: '' },
        order: 12,
        orderLabel: 12,
        label: 'All your wealth (financial assets, real estates, movables, etc.)',
        question: 'wealthQuestion',
        options: suitabilityTestWealth,
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.financialSituation,
        radioBtn: true,
    },
    disposableIncome: {
        value: 'disposableIncome',
        localization: { id: '', defaultMessage: '' },
        order: 13,
        orderLabel: 13,
        label: 'Regular disposable income (income-expenses)',
        question: 'disposableIncomeQuestion',
        options: suitabilityTestDisposableIncome,
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.financialSituation,
        radioBtn: true,
    },
    incomeSources: {
        value: 'incomeSources',
        localization: { id: '', defaultMessage: '' },
        order: 14,
        orderLabel: 14,
        label: 'Income sources (primarily)',
        question: 'incomeSourcesQuestion',
        options: suitabilityTestIncomeSources,
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.financialSituation,
        radioBtn: true,
    },
    characterizeInvestment: {
        value: 'characterizeInvestment',
        localization: { id: '', defaultMessage: '' },
        order: 15,
        orderLabel: 15,
        label: 'Amount characterizing your investment transactions',
        question: 'characterizeInvestmentQuestion',
        options: suitabilityTestCharacterizeInvestment,
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.financialSituation,
        radioBtn: true,
    },
    riskWillingness: {
        value: 'riskWillingness',
        localization: { id: '', defaultMessage: '' },
        order: 16,
        orderLabel: 16,
        label: 'Please select one from the following statements that is the most specific in terms of your willingness to take risks (only one answer is to be given)',
        question: 'riskWillingnessQuestion',
        options: suitabilityTestRiskWillingness,
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.investmentExperience,
        radioBtn: true,
    },
    mostSpecific: {
        value: 'mostSpecific',
        localization: { id: '', defaultMessage: '' },
        order: 17,
        orderLabel: 17,
        label: 'Which one is the most specific to you from the following statements?',
        question: 'mostSpecificQuestion',
        options: suitabilityTestMostSpecific,
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.investmentExperience,
        radioBtn: true,
    },
    termsConditions: {
        value: 'termsConditions',
        localization: { id: '', defaultMessage: '' },
        order: 18,
        orderLabel: 18,
        label: 'By Completing this form you confirm and declare that:',
        question: 'termsConditionsQuestion',
        options: suitabilityTestTermsConditions,
        mandatory: () => true,
        relevant: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu],
        step: suitabilityTestSteps.investmentExperience,
        multiselect: true,
    },
}));
const suitabilityTestStatuses = generateKeys({
    underReview: {
        value: 'under_review',
        label: 'Under Review',
    },
    approved: {
        value: 'approved',
        label: 'Approved',
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
    },
    pending: {
        value: 'pending',
        label: 'Pending',
    },
});
const suitabilityTestScoreResult = generateKeys({
    low: {
        value: 'low',
        label: 'Low Risk Appetite',
    },
    medium: {
        value: 'medium',
        label: 'Medium Risk Appetite',
    },
    high: {
        value: 'high',
        label: 'High Risk Appetite',
    },
});
export { suitabilityTestSteps, suitabilityTestYearsOfExperience, suitabilityTestStatuses, suitabilityTestTermsConditions, suitabilityTestPrimaryInvestmentGoal, suitabilityTestPrimaryInvestmentTerm, suitabilityTestInvestmentFrequency, suitabilityTestPercentageInvestmentAvailable, suitabilityTestWealth, suitabilityTestDisposableIncome, suitabilityTestIncomeSources, suitabilityTestCharacterizeInvestment, suitabilityTestRiskWillingness, suitabilityTestMostSpecific, suitabilityTestScoreResult, };
